export const COLORS = {
  ORANGE: "#D97A07",
  NAVY: "#0D2E4D",
  GREY: "#777",
  WHITE: "#fff",
};

export const GOVERNANCE_NODE_STYLE = {
  background: COLORS.ORANGE,
  color: COLORS.NAVY,
  border: `2px solid ${COLORS.NAVY}`,
  borderRadius: "4px",
  fontFamily: "poppins",
  padding: "15px 20px",
  fontSize: "12px",
  fontWeight: "600",
};

export const MANAGEMENT_NODE_STYLE = {
  background: COLORS.NAVY,
  color: COLORS.WHITE,
  border: `2px solid ${COLORS.NAVY}`,
  borderRadius: "4px",
  fontFamily: "poppins",
  padding: "15px 20px",
  fontSize: "12px",
  fontWeight: "600",
  minWidth: "140px",
  textAlign: "center",
};

export const IMPLEMENTATION_GROUP_STYLE = {
  background: "transparent",
  border: `3px solid ${COLORS.GREY}`,
  borderRadius: "8px",
  width: "400px",
  height: "240px",
  minWidth: "400px",
};

// Edge styles
export const GOVERNANCE_EDGE_STYLE = {
  stroke: COLORS.ORANGE,
  strokeWidth: 2,
  strokeDasharray: "5,5",
};

export const MANAGEMENT_EDGE_STYLE = {
  stroke: COLORS.NAVY,
  strokeWidth: 2,
  strokeDasharray: "5,5",
};

export const CROSS_LAYER_EDGE_STYLE = {
  stroke: COLORS.GREY,
  strokeWidth: 2,
};
